import React, { useEffect, useRef, useState } from 'react';
import './HeroScroll.css'
import Slider from 'react-slick'

import 'aos/dist/aos.css';
import AOS from 'aos';


function HeroScroll() {

    const borderRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);
  
    useEffect(() => {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              setIsVisible(true);
              observer.unobserve(entry.target); 
            }
          });
        },
        { threshold: 0.1 } 
      );
  
      if (borderRef.current) {
        observer.observe(borderRef.current);
      }
  
      return () => {
        if (borderRef.current) {
          observer.unobserve(borderRef.current);
        }
      };
    }, []);

    useEffect(() => {
        AOS.init({
          // once: true, // Uncomment if you want the animation to happen only once
          // duration: 1000, // Uncomment to set the duration of animations in milliseconds
          // other options can go here
        });
      }, []);
      

    var settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
    };
    return (
        <>




            <section id="second" className="discover-sec">
                <div className="container">
                    <div className="row">
                        {/* Mobile slider start */}
                        <div className="col-md-12 d-lg-none d-md-none d-block">

                            <Slider {...settings}>

                                <div>
                                    <img src="/img/Autodealerships.png" alt="A smiling couple stands inside an auto dealership, shaking hands with a suited salesperson. A white car is visible in the background. The caption reads, Auto Dealerships - Serve the community while attracting new customers.
" />
                                </div>
                                <div>
                                    <img src="/img/marketplacehost.png" alt="A man and a woman standing near an SUV with its trunk open. The woman holds a baby, and the man is unloading items from the car. They are in front of a house with a thatched roof. The text overlay reads, 'Marketplace Hosts More control, more profit,' same experience.
" />
                                </div>
                                <div>
                                    <img src="/img/marketplacehostcopy.webp" alt="A smiling couple stands close together, embracing in front of a modern building. They look content and happy. The text at the bottom reads, 'Marketplace Hosts. Take full control of your business.
" />
                                </div>
                                <div>
                                    <img src="/img/Rentalagencies.webp" alt="A happy family of three, including a man, woman, and child, stand in front of a house and a vehicle, all smiling. They are dressed casually. The text reads 'Rental Agencies: Attract high-value, self-service customers.
" />
                                </div>
                                <div>
                                    <img src="/img/Serviceandrepair.webp" alt="A smiling couple stands inside an auto dealership, shaking hands with a suited salesperson. A white car is visible in the background. The caption reads, Auto Dealerships - Serve the community while attracting new customers.
" />
                                </div>
                                <div>
                                    <img src="/img/Rentalagencies2.webp" alt="A person stands beside an electric vehicle being charged, with sunlight illuminating the scene. The text overlay reads: 'Rental Agencies: Attract high-value, self-service customers.
" />
                                </div>

                            </Slider>

                        </div>
                        {/* Mobile slider End */}

                        <div className="col-xl-6 col-lg-6 col-md-9 left-side ">
                            <div className="row align-items-center">
                                <div className="col-md-12 ps-0 pe-0">
                                    <h2 className="discover">
                                        Discover why rental operators and
                                        entrepreneurs choose rentid to scale
                                        their business -
                                        <span className="text-bg">take control today.</span>
                                    </h2>
                                    <div className="row pt-3">
                                        <div className="col-md-5 scroll-sec-text">
                                            <div ref={borderRef} className={`gredientLine ${isVisible ? 'visible' : ''}`}>
                                                <h3>Hundreds</h3>
                                                <p className="">
                                                    of automated workflows, 
                                                    one single platform
                                                </p>
                                            </div>
                                           
                                        </div>
                                        <div className="col-md-5 scroll-sec-text">
                                            <div ref={borderRef} className={`gredientLine ${isVisible ? 'visible' : ''}`}>
                                                <h3>Four +</h3>
                                                <p className="">
                                                    On-rent daily insurance 
                                                    and protection plans
                                                </p>
                                            </div>
                                           
                                        </div>
                                    </div>
                                    <div className="row discocer-card">
                                        <div className="col-md-5 scroll-sec-text">
                                            <div ref={borderRef} className={`gredientLine ${isVisible ? 'visible' : ''}`}>
                                                <h3>10 seconds</h3>
                                                <p className="">
                                                    or less to verify & qualify 
                                                    drivers and enhance safety
                                                </p>
                                            </div>
                                           
                                        </div>
                                        <div className="col-md-5 scroll-sec-text">
                                            <div ref={borderRef} className={`gredientLine ${isVisible ? 'visible' : ''}`}>
                                                <h3>$57.5B</h3>
                                                <p className="">
                                                    U.S. car rental market to
                                                     capture with our solutions
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-5 col-lg-6 col-md-9 position-relative heroscroll-space pe-0">
                            <div className="overlaycolor"></div>
                            {/* <div className="row scroll-img">
                                <div className="col-lg-6 col-md-6 col-6 text-center position-relative">
                                    <div className="photobanner">
                                        <img className="first" src="/img/Autodealerships.png" alt="Image 1" />
                                        <img src="/img/marketplacehost.png" alt="Image 2" />
                                        <img src="/img/marketplacehostcopy.webp" alt="Image 3" />

                                        <img src="/img/Autodealerships.png" alt="Image 1" />
                                        <img src="/img/marketplacehost.png" alt="Image 2" />
                                        <img src="/img/marketplacehostcopy.webp" alt="Image 3" />

                                        <img src="/img/Autodealerships.png" alt="Image 1" />
                                        <img src="/img/marketplacehost.png" alt="Image 2" />
                                        <img src="/img/marketplacehostcopy.webp" alt="Image 3" />

                                        <img src="/img/Autodealerships.png" alt="Image 1" />
                                        <img src="/img/marketplacehost.png" alt="Image 2" />
                                        <img src="/img/marketplacehostcopy.webp" alt="Image 3" />

          
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-6 text-center">
                                    <div className="photobanner">
                                        <img className="first1" src="/img/Rentalagencies.webp" alt="A happy family of three, including a man, woman, and child, stand in front of a house and a vehicle, all smiling. They are dressed casually. The text on the image reads 'Rental Agencies: Attract high-value, self-service customers.
" />
                                        <img src="/img/Serviceandrepair.webp" alt="A smiling man with a beard, wearing a gray collared shirt, stands in what appears to be an auto repair shop. Behind him, the blurred background shows car parts and equipment. Below the image, text reads: "Service & Repair: When they ask, say 'YES! I have a loaner car for rent.'." />
                                        <img src="/img/Rentalagencies2.webp" alt="Image 6" />

                                        <img src="/img/Rentalagencies.webp" alt="A happy family of three, including a man, woman, and child, stand in front of a house and a vehicle, all smiling. They are dressed casually. The text on the image reads 'Rental Agencies: Attract high-value, self-service customers.
" />
                                        <img src="/img/Serviceandrepair.webp" alt="A smiling man with a beard, wearing a gray collared shirt, stands in what appears to be an auto repair shop. Behind him, the blurred background shows car parts and equipment. Below the image, text reads: "Service & Repair: When they ask, say 'YES! I have a loaner car for rent.'." />
                                        <img src="/img/Rentalagencies2.webp" alt="Image 6" />


                                        <img src="/img/Rentalagencies.webp" alt="A happy family of three, including a man, woman, and child, stand in front of a house and a vehicle, all smiling. They are dressed casually. The text on the image reads 'Rental Agencies: Attract high-value, self-service customers.
" />
                                        <img src="/img/Serviceandrepair.webp" alt="A smiling man with a beard, wearing a gray collared shirt, stands in what appears to be an auto repair shop. Behind him, the blurred background shows car parts and equipment. Below the image, text reads: "Service & Repair: When they ask, say 'YES! I have a loaner car for rent.'." />
                                        <img src="/img/Rentalagencies2.webp" alt="Image 6" />


                                        <img src="/img/Rentalagencies.webp" alt="A happy family of three, including a man, woman, and child, stand in front of a house and a vehicle, all smiling. They are dressed casually. The text on the image reads 'Rental Agencies: Attract high-value, self-service customers.
" />
                                        <img src="/img/Serviceandrepair.webp" alt="A smiling man with a beard, wearing a gray collared shirt, stands in what appears to be an auto repair shop. Behind him, the blurred background shows car parts and equipment. Below the image, text reads: "Service & Repair: When they ask, say 'YES! I have a loaner car for rent.'." />
                                        <img src="/img/Rentalagencies2.webp" alt="Image 6" />     

                                        
                                    </div>
                                </div>
                            </div> */}
                            <div className="row scroll-img">
                                <div className="col-md-6">
                                <div className="marquee">
                                    <div className="marquee-content">
                                    <img src="./img/Autodealerships.webp" alt="A smiling couple stands inside an auto dealership, shaking hands with a suited salesperson. A white car is visible in the background. The caption reads, Auto Dealerships - Serve the community while attracting new customers.
"/>
                                    <img src="/img/marketplacehost.webp" alt="A man and a woman standing near an SUV with its trunk open. The woman holds a baby, and the man is unloading items from the car. They are in front of a house with a thatched roof. The text overlay reads, 'Marketplace Hosts, More control, more profit,' same experience.
"/>
                                    <img src="/img/marketplacehostcopy.webp" alt="A smiling couple stands close together, embracing in front of a modern building. They look content and happy. The text at the bottom reads, 'Marketplace Hosts. Take full control of your business.
"/>
                                    
                                    <img src="./img/Autodealerships.webp" alt="A smiling couple stands inside an auto dealership, shaking hands with a suited salesperson. A white car is visible in the background. The caption reads, Auto Dealerships - Serve the community while attracting new customers.
"/>
                                    <img src="/img/marketplacehost.webp" alt="A man and a woman standing near an SUV with its trunk open. The woman holds a baby, and the man is unloading items from the car. They are in front of a house with a thatched roof. The text overlay reads, 'Marketplace Hosts. More control, more profit, same experience.
"/>
                                    <img src="/img/marketplacehostcopy.webp" alt="A smiling couple stands close together, embracing in front of a modern building. They look content and happy. The text at the bottom reads, 'Marketplace Hosts. Take full control of your business.
"/>
                                    </div>
                                </div>
                                </div>
                                <div className="col-md-6">
                                <div className="marquee">
                                    <div className="marquee-content1">
                                    <img src="/img/Rentalagencies.webp" alt="A smiling couple stands inside an auto dealership, shaking hands with a suited salesperson. A white car is visible in the background. The caption reads, Auto Dealerships - Serve the community while attracting new customers.
"/>
                                    <img src="/img/Serviceandrepair.webp" alt="Image 6"/>
                                    <img src="/img/Rentalagencies2.webp" alt="A person stands beside an electric vehicle being charged, with sunlight illuminating the scene. The text overlay reads: 'Rental Agencies: Attract high-value, self-service customers.
"/>
                                    
                                    <img src="/img/Rentalagencies.webp" alt="A smiling family of three stands outside a modern house. The mother and father, both wearing plaid shirts, stand with their arms around their young son, who is also wearing a checked shirt. A caption reads, 'Marketplace Hosts: Family business you can own.
"/>
                                    <img src="/img/Serviceandrepair.webp" alt="A smiling couple stands inside an auto dealership, shaking hands with a suited salesperson. A white car is visible in the background. The caption reads, Auto Dealerships - Serve the community while attracting new customers.
"/>
                                    <img src="/img/Rentalagencies2.webp" alt="A person stands beside an electric vehicle being charged, with sunlight illuminating the scene. The text overlay reads: 'Rental Agencies: Attract high-value, self-service customers.
"/>
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default HeroScroll